import React, { useEffect, useState } from "react";
import axios from "axios";

const Cards = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCards();
  }, []);

  const fetchCards = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/cards?taxonomy=courses`
      );
      setCards(response.data);
    } catch (error) {
      console.error("Error fetching cards:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-5">
        <div className="container text-center">
          <div className="d-flex justify-content-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold text-dark mb-3">
            Explore Our Courses
          </h2>
          <p className="lead text-muted">
            Comprehensive learning paths for all skill levels
          </p>
        </div>
        <div className="row g-4">
          {cards.map((card) => (
            <div key={card.id} className="col-lg-4 col-md-6">
              <div className="card border-0 shadow-sm h-100 transition-all hover-lift">
                {card.image && (
                  <img
                    src={card.image}
                    className="card-img-top"
                    alt={card.title}
                    style={{ objectFit: "cover", height: "200px" }}
                  />
                )}
                <div className="card-body p-4">
                  <h5 className="card-title fw-semibold text-dark">
                    {card.title}
                  </h5>
                  <p className="card-text text-muted">{card.description}</p>
                  {card.url && card.button_text && (
                    <a href={card.url} className="btn btn-primary mt-3">
                      {card.button_text}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}

          {/* Placeholder for missing cards */}
          {cards.length < 3 &&
            [...Array(3 - cards.length)].map((_, i) => (
              <div key={`placeholder-${i}`} className="col-lg-4 col-md-6">
                <div className="card border-0 shadow-sm h-100 bg-light">
                  <div className="card-body p-4 d-flex align-items-center justify-content-center text-center">
                    <div>
                      <i className="bi bi-clock-history display-4 text-muted mb-3"></i>
                      <h6 className="text-muted">New Course Coming Soon</h6>
                      <small className="text-muted">
                        Stay tuned for exciting updates
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Cards;
